<template>
  <div class="">

    <div class="sticky-top d-flex justify-content-around nav bg-primary nav">
      <router-link class="navItem d-flex justify-content-center" :to="{ name: 'Home', params: {} }">
        <h5>Home</h5>
      </router-link>
      <router-link class="navItem d-flex justify-content-center" :to="{ name: 'Team', params: {} }">
        <h5>Our Team</h5>
      </router-link>
      <router-link class="navItem d-flex justify-content-center" :to="{ name: 'Projects', params: {} }">
        <h5>Projects</h5>
      </router-link>
      <router-link class="navItem d-flex justify-content-center" :to="{ name: 'Affilates', params: {} }">
        <h5>Affilates</h5>
      </router-link>
      <router-link class="navItem d-flex justify-content-center" :to="{ name: 'Contact', params: {} }">
        <h5>Contact Us</h5>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Nav',
  data() {
    return {

    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
    text-decoration: none !important;
    color: #e9ecef !important;
}
h5{
  margin-top: 0.5rem;
}
.navItem{
  transition: background-color .5s ease-out !important;
  width: 20%;
}
.navItem:hover{
  background-color: #C19A35 !important;
  opacity: 1;
}
@media (min-width: 570px) {
  h5{
    font-size: 1.171875rem;
  }
}
@media (max-width: 570px) {
  h5{
    font-size: 3vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Nav.vue